import React, { FC } from 'react';
import { useAction, useAtom } from '@reatom/npm-react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { pushNotification } from '@whitesharx/starfall-frontend-ui-kit';
import {
  AdBlockedModal,
  DailyLimitModal,
  useModal,
  useServices,
  useSettingsQuery,
} from '@whitesharx/starfall-frontend-core';

import { getAnalysisLimitAction } from '../../../model';
import VIPModal from '~/src/components/VIPModal';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  onAdViewed: () => void;
};

const AnalysisLimitModal: FC<Props> = ({ isOpen, onRequestClose, onAdViewed }) => {
  const { Adsense } = useServices();
  const settingsQuery = useSettingsQuery();

  const [analysisLimitStatus] = useAtom(getAnalysisLimitAction.statusesAtom);
  const [analysisLimit] = useAtom(getAnalysisLimitAction.dataAtom);
  const getAnalysisLimit = useAction(getAnalysisLimitAction);

  const { isOpen: isOpenAdBlockedModal, open: openAdBlockedModal, close: closeAdBlockedModal } = useModal();
  const { isOpen: isOpenVIPModal, open: openVIPModal, close: closeVIPModal } = useModal();

  const timeoutMS = (settingsQuery.data?.meta.common.analysisTime || 0) * 1000;
  const leftMilliseconds = analysisLimit?.date ? new Date(analysisLimit.date).getTime() + timeoutMS - Date.now() : 0;

  const checkDailyLimit = async (onSuccess: () => void) => {
    const limitData = await getAnalysisLimit();

    if (limitData.adDate) {
      pushNotification({
        type: 'danger',
        title: t('daily-limit-modal.title'),
      });

      return;
    }

    onSuccess();
  };

  const onShowAd = () => {
    if (!Adsense.blocked) {
      checkDailyLimit(() => {
        Adsense.showReward({
          name: 'analysis-daily-limit',
          adViewed: () => {
            checkDailyLimit(onAdViewed);
          },
          adDismissed: onRequestClose,
          onError: () => {
            pushNotification({
              type: 'danger',
              title: t('failed-load-adsense'),
            });
          },
        });
      });
    } else {
      openAdBlockedModal();
    }
  };

  return (
    <>
      <DailyLimitModal
        type="analysis"
        leftMilliseconds={leftMilliseconds}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        onGetUnlimited={openVIPModal}
        onGetReward={onShowAd}
        loading={analysisLimitStatus.isPending}
        rewardAvailable={!analysisLimit?.adDate}
      />
      {isOpenAdBlockedModal && <AdBlockedModal isOpen={isOpenAdBlockedModal} onRequestClose={closeAdBlockedModal} />}
      {isOpenVIPModal && <VIPModal onClose={closeVIPModal} />}
    </>
  );
};

export default AnalysisLimitModal;
